import { defineChain } from 'viem';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

const viemRobinhood = /*#__PURE__*/ defineChain({
  id: 4663,
  name: 'Robinhood Chain',
  nativeCurrency: {
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH',
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 0,
    },
  },
  rpcUrls: {
    default: { http: ['https://rpc.mainnet.chain.robinhood.com'] },
  },
  blockExplorers: {
    default: {
      name: 'Robinhood Chain Explorer',
      url: 'https://robinhoodchain.blockscout.com',
    },
  },
  testnet: false,
});

export const robinhood = {
  displayName: 'Robinhood Chain',
  runtime: 'evm',
  viemChain: viemRobinhood,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 3,
  decoration: {
    color: '#CCFF00',
    get contrastColor() {
      return getContrastColor(this.color);
    },
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'robinhood-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://robinhoodchain.blockscout.com',
        token: 'https://robinhoodchain.blockscout.com/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    across: { chainKey: 'robinhood' },
    lifi: { chainKey: 'out' },
    relay: { chainKey: 'robinhood' },
  }),
  services: defaultServices({
    codex: {
      networkId: 4663,
      nativeLiquidityAddress: '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73',
    },
    coingecko: {
      networkId: 'robinhood',
      platformId: 'robinhood',
    },
    coingeckoDex: {
      networkId: 'robinhood',
    },
    zerion: {
      chainKey: 'robinhood',
    },
    qnStreams: {
      networkKey: 'robinhood-mainnet',
    },
    alchemy: { chainSlug: 'robinhood-mainnet' },
    pimlico: { chainSlug: 'robinhood' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
